module.exports = __webpack_public_path__ + "img/mojito-xxl.51580bd4.png";